import routerOptions0 from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/var/www/projects/nuxt.hillceramic.dk/releases/20261105082105Z/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}